<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Ano/Mês</label>
                <div class="field-label field-label-center">{{ objEdicao.anomes }}</div>
            </div>
            
            <div class="form-item-char20">
                <label class="label-caption">Protocolo</label>
                <div class="field-label field-label-center">{{ objEdicao.protocolo }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption">Estabelecimento</label>
                <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption">Responsável</label>
                <div class="field-label">{{ globalStore.nmusuario }}</div>
            </div>
        </div>


        <div v-if="!modoItens">
            <!-- <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Observações</label>
                    <textarea v-model="objEdicao.informacoes" maxlength="1000" rows="5" style="resize: none;"/>
                </div>
            </div> -->

            <div class="row-end">
                <button v-if="objEdicao.anomes != 0" class="btn-confirm" @click="salvarCabecalho">Iniciar Preenchimento</button>
                <button @click="closeForm">Retornar</button>
            </div>
        </div>
        
    
    
        <div v-if="modoItens">
            <div class="row row-space">
                <div class="form-item-data">
                    <label class="label-caption">Recebimento</label>
                    <input type="date" v-model="objEdicaoItem.dtrecebimento" />
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Hora</label>
                    <input type="text" class="input-center" v-model="objEdicaoItem.hrrecebimento" v-time-mask/>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Veículo</label>
                    <input type="text" class="input-center" v-model="objEdicaoItem.placa_veiculo" maxlength="7" v-uppercase/>
                </div>

                <div class="form-item-char15">
                    <label class="label-caption">Nro Tanque</label>
                    <input type="text" class="input-right" v-model="edNroTanque" v-number />
                </div>

                <div class="form-item-char15">
                    <label class="label-caption">Quantidade</label>
                    <input type="text" class="input-right" v-model="edQuantidade" v-decimal />
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Lote</label>
                    <input type="text" class="input-center" v-model="objEdicaoItem.lote" maxlength="100" v-uppercase />
                </div>

                <div class="form-item">
                    <label class="label-caption">Fornecedor</label>
                    <input type="text" v-model="objEdicaoItem.nmfornecedor" maxlength="100" v-uppercase />
                </div>
            </div>



            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Temperatura</label>
                    <input type="text" class="input-right" v-model="edTemperatura" v-decimal />
                </div>

                <div class="form-item">
                    <label class="label-caption">Alizarol Estável</label>
                    <input type="text" class="input-right" v-model="edVlAlizarol" v-decimal />
                </div>

                <div class="form-item">
                    <label class="label-caption">Acidez</label>
                    <input type="text" class="input-right" v-model="edVlAcidez" v-decimal />
                </div>

                <div class="form-item">
                    <label class="label-caption">Densidade</label>
                    <input type="text" class="input-right" v-model="edVlDensidade" v-decimal />
                </div>

                <ToggleButton 
                    v-model="ckFosfatase"
                    label-true="+"
                    label-false="-"
                    label-caption="Fosfatase"
                    btnWidth="60px"
                />

                <ToggleButton
                    v-model="ckPeroxidase"
                    label-true="+"
                    label-false="-"
                    label-caption="Peroxidase"
                    btnWidth="60px"
                />

                <ToggleButton
                    v-model="ckDestinoLC"
                    label-true="Liberado"
                    label-false="Condenado"
                    label-caption="Destino"
                    btnWidth="90px"
                />
            </div>


            <div class="row">
                <div class="form-item">
                    <label class="label-caption">Responsável</label>
                    <input type="text" v-model="objEdicaoItem.nmresponsavel" maxlength="100" v-uppercase />
                </div>

                <button class="btn-confirm" @click="salvarItem">Salvar Ítem</button>
                <button class="btn-cancel" @click="abrirModal">Encerrar e Assinar</button>
                <button @click="closeForm">Sair</button>
            </div>            
        </div>
    </div>

    <div v-if="modoItens && lsItens.length > 0" class="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th>Data</th>
                    <th>Hora</th>
                    <th>Veículo</th>
                    <th>Tanque</th>
                    <th>Quantidade</th>
                    <th>Destino</th>
                    <th>Responsável</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsItens" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtrecebimento) }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatTimeFromJson(obj.hrrecebimento) }}</td>
                    <td class="col-width-char15 center">{{ obj.placa_veiculo }}</td>
                    <td class="col-width-char10 center">{{ Funcoes.formatInteger(obj.nrotanque) }}</td>
                    <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.qtd) }}</td>
                    <td class="col-width-char15 center">{{ obj.nmdestino_lc }}</td>
                    <td>{{ obj.nmresponsavel }}</td>
                    <td class="col-width-char05"><div class="row-left">
                        <button class="btn-icon btn-icon--trash" @click="excluiItem(obj)"></button>
                    </div></td>
                </tr>
            </tbody>
        </table>
    </div>

    <ConfirmModal ref="confirmModal" />

    <DialogOkModal 
        v-if="showOkModal" 
        :message="msgOkModal" 
        @close="closeForm" 
        @confirmed="closeForm" />

    <SenhaModal ref="senhaModalRef" />
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { criarAssinatura } from '@/models/assinatura';
import { criarPlaLeite } from '@/models/plaLeite';
import { criarPlaLeiteItem } from '@/models/plaLeiteItem';
import { Funcoes } from '@/funcoes/funcoes';
import { genericDelete, genericGet, genericPost, genericPut } from '@/funcoes/api';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';
import ToggleButton from '@/components/ToggleButton.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});
const senhaModalRef = ref(null);

const ckDestinoLC = ref(null);
const ckEmiteSalvo = ref(false);
const ckFosfatase = ref(null);
const ckPeroxidase = ref(null);
const confirmModal = ref(null);
const edNroTanque = ref(null);
const edQuantidade = ref(null);
const edTemperatura = ref(null);
const edVlAcidez = ref(null);
const edVlAlizarol = ref(null);
const edVlDensidade = ref(null);
const isLoading = ref(false);
const lsItens = ref([]);
const modoItens = ref(false);
const msgAlerta = ref(null);
const msgOkModal = ref('Planilha encerrada e homologada com sucesso.');
const objAssinatura = ref(criarAssinatura());
const objEdicao = ref(criarPlaLeite());
const objEdicaoItem = ref(criarPlaLeiteItem());
const showOkModal = ref(false);

async function abrirModal() {
    encerrarDigitacao();

    // const confirmado = await confirmModal.value.show({
    //     message: 'Deseja finalizar digitação e encaminhar documento para assinatura?',
    //     confirmText: 'Sim',
    //     cancelText: 'Não'
    // })

    // if (confirmado) {
    //     encerrarDigitacao();
    // }
}

const closeForm = () => {
    if (ckEmiteSalvo.value) emit('save');
    emit('close'); 
};

async function encerrarDigitacao(){
    try{
        msgAlerta.value=null;

        const senhaDigitada = await senhaModalRef.value.showModal();
        if (!senhaDigitada) return;

        isLoading.value=true;

        objAssinatura.value.idep = globalStore.idep;
        objAssinatura.value.idusuario = globalStore.idusuario;
        objAssinatura.value.idsessao = globalStore.idlogin;
        objAssinatura.value.nmusuario = globalStore.nmusuario;
        objAssinatura.value.vssistema = `${globalStore.appname} vs. ${globalStore.appver}`;
        objAssinatura.value.ass_conteudo = `REF:PLALEITE|IDREF:${objEdicao.value.id}|PROT:${objEdicao.value.protocolo}`;
        objAssinatura.value.ass_senha = senhaDigitada;
        objAssinatura.value.ass_tipoauth = 'senha pessoal via sistema WEB';
        objAssinatura.value.doc_idorigem = objEdicao.value.id;
        objAssinatura.value.doc_tipo = 'PLALEITE';

        const respAss = await genericPut('/pla/plaleite/homologar', objAssinatura.value);
        if (respAss.bolok === 1){
            ckEmiteSalvo.value=true;
            showOkModal.value=true;
        } else {
            msgAlerta.value=`ATENÇÃO: ${respAss.erro}`;
        }
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

const excluiItem = async(item) => {
    const confirmado = await confirmModal.value.show({
        message: 'Confirma exclusão do ítem?',
        confirmText: 'Sim',
        cancelText: 'Não'
    });
    if (confirmado){
        try{
            msgAlerta.value=null;
            isLoading.value=true;
            await genericDelete({id: item.id, strparam1: 'plaleite_itens', idusuario: globalStore.idusuario});
            await lerItens();
        } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
        }finally{isLoading.value=false;}
    }
}

const lerDados = async() => {
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        let req=null;
        if (props.idEdicao==0){
            req = await genericGet('/pla/plaleite_new', {idestabelecimento: globalStore.idestabelecimento});
            Object.assign(objEdicao.value, req);
        }else{
            req = await genericGet('/cad/plaleite', {id: props.idEdicao});
            Object.assign(objEdicao.value, req[0]);
            modoItens.value=true;
            await lerItens();
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
};

async function lerItens(){
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        const itens = await genericPost('/lspla/plaleite/itens', {id: objEdicao.value.id});
        lsItens.value = itens;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

const salvarItem = async () => {
    msgAlerta.value = salvarItemDadosOk();
    if (msgAlerta.value) return;

    try {
        isLoading.value = true;

        objEdicaoItem.value.id = 0;
        objEdicaoItem.value.idplaleite = objEdicao.value.id;
        objEdicaoItem.value.nrotanque = Funcoes.integerFromString(edNroTanque.value);
        objEdicaoItem.value.qtd = Funcoes.decimalFromString(edQuantidade.value);
        objEdicaoItem.value.temperatura = Funcoes.decimalFromString(edTemperatura.value);
        objEdicaoItem.value.vlalizarol = Funcoes.decimalFromString(edVlAlizarol.value);
        objEdicaoItem.value.vlacidez = Funcoes.decimalFromString(edVlAcidez.value);
        objEdicaoItem.value.vldensidade = Funcoes.decimalFromString(edVlDensidade.value);
        objEdicaoItem.value.ckdestino_lc = ckDestinoLC.value === null ? '' : ckDestinoLC.value ? 'L' : 'C';
        objEdicaoItem.value.fosfatase = ckFosfatase.value === null ? '' : ckFosfatase.value ? '+' : '-';
        objEdicaoItem.value.peroxidase = ckPeroxidase.value === null ? '' : ckPeroxidase.value ? '+' : '-';
        objEdicaoItem.value.idlogin = globalStore.idlogin;
        objEdicaoItem.value.idusuario = globalStore.idusuario;

        const response  = await genericPut('/cad/plaleite_item', objEdicaoItem.value);
        if (response.bolok === 1){
            ckEmiteSalvo.value=true;
            ckDestinoLC.value = null;
            ckFosfatase.value = null;
            ckPeroxidase.value = null;
            edQuantidade.value = null;
            lerItens();
        }else{
            msgAlerta.value=response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally{isLoading.value=false;}
}


function salvarItemDadosOk(){    
    let r = Validar.dataNoMes(objEdicaoItem.value.dtrecebimento, objEdicao.value.anomes);
    if (!r.ok) return r.msg;
    r = Validar.hora(objEdicaoItem.value.hrrecebimento);
    if (!r.ok) return r.msg;
    r = Validar.numeroPositivo(edQuantidade.value, 'Informe corretamente a quantidade');
    if (!r.ok) return r.msg;
    if (ckDestinoLC.value === null) return 'Informe destino se "Liberado" ou "Condenado"';
    return null;
}


const salvarCabecalho = async() => {
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const response = await genericPut('/cad/plaleite', objEdicao.value);
        if (response.bolok === 1){
            if (objEdicao.value.id==0) objEdicao.value.id = response.id;
            ckEmiteSalvo.value=true;
            modoItens.value=true;
            await lerItens();
        }else{msgAlerta.value=`ATENÇÃO: ${response.erro}`;}
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}

onMounted(lerDados);
</script>